var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.appVersion)?_c('div',{staticClass:"app-version text-v-ui-text-monochrome-55 note-12-reg-400"},[_vm._v(" Версия платформы "+_vm._s(_vm.appVersion)+" ")]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }